var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-header-box"},[_c('v-header',{on:{"changeProject":_vm.changeProject}}),_c('v-card2',{attrs:{"propsData":_vm.projectCode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }